import React from 'react'

export const InputMessageError = ({ children, className = '', color = 'is-danger', style = {} }) => {
  return (
    <p className={`help ${color} ${className}`} style={style}>
      {children}
    </p>
  )
}
